// extracted by mini-css-extract-plugin
module.exports = {"item":"InstructorList_item__3aatp"};